import React, { useState, useEffect } from "react";
import { usePatchDispatchDocMutation } from "./ProcurementApiSlice";
import { toast } from "react-toastify";
import { Grid } from "@mui/material";
import swal from "sweetalert";
import { Tag } from "antd";

export const DispatchAllDoc = ({
  procCode,
  user_id,
  refetch,
  FullList,
  AddResponse,
  refetchAddResponse,
  refetchAddress,
}) => {
  // const { data: AddResponse, refetch:refetchAddResponse } = useGetDispatchAllDocumentsQuery(procCode);
  const [dispatchRecords, setDispatchRecords] = useState([]);
  const [patchDoc] = usePatchDispatchDocMutation();
  const allDocumentTypes = [
    "Mandi Document",
    "Transporter Bilty",
    "E-way Bill",
  ];
  const [selectedFiles, setSelectedFiles] = useState({});
  const [Vehicle, setVehicle] = useState({
    vehicle_type: "",
    vehicle_number: "",
  });
  useEffect(() => {
    if (AddResponse !== undefined) {
      setDispatchRecords(AddResponse?.data);
    }
  }, [AddResponse]);

  const handleFileChange = (event, docType) => {
    // const file = event.target.files[0];
    // setSelectedFiles((prevFiles) => ({
    //   ...prevFiles,
    //   [docType]: file,
    // }));
    const { type, value, files } = event.target;

    if (docType === "mandi_document") {
      setSelectedFiles((prevData) => ({
        ...prevData,
        [docType]: [...(prevData[docType] || []), ...files],
      }));
    } else {
      setSelectedFiles((prevData) => ({
        ...prevData,
        [docType]: files[0],
      }));
    }
  };

  const handleUploadClick = (payloadId) => {
    if (Object.keys(selectedFiles).length === 0) {
      swal("Select File", {
        icon: "warning",
        title: "No files selected. Please choose files to upload.",
        timer: 2000,
      });
      return;
    }

    const formPayload = new FormData();
    formPayload.append("entity_type", "Seller");
    formPayload.append("user_id", user_id);
    formPayload.append("category", "Procurement");
    Object.keys(selectedFiles).forEach((docType) => {
      if (docType === "mandi_document") {
        selectedFiles[docType].forEach((file, index) => {
          formPayload.append(`${docType}`, file);
        });
      } else {
        formPayload.append(
          docType === "transporter_bilty"
            ? "transporter_billty"
            : docType === "e-way_bill"
            ? "eway_bill"
            : docType,
          selectedFiles[docType]
        );
      }
    });

    let id = payloadId;
    patchDoc({ id, formPayload })
      .unwrap()
      .then(async (data) => {
        toast.success("Documents Uploaded Successfully !!");
        setSelectedFiles({});
        refetchAddResponse();
        await refetch();
      })
      .catch((error) => {
        toast.error(`${error.data.message}`);
      });
  };

  const handlePreArrival = (e, payloadId) => {
    e.preventDefault();
    const formPayload = new FormData();
    formPayload.append("entity_type", "Seller");
    formPayload.append("user_id", user_id);
    formPayload.append("category", "Procurement");
    formPayload.append("vehicle_type", Vehicle.vehicle_type);
    formPayload.append("vehicle_number", Vehicle.vehicle_number);
    let id = payloadId;
    patchDoc({ id, formPayload })
      .unwrap()
      .then(() => {
        toast.success("Successfully Submitted!!");
        setSelectedFiles({});
        refetchAddResponse();
        refetch();
      })
      .catch((error) => {
        toast.error(`${error.data.message}`);
      });
  };

  return (
    <div>
      {dispatchRecords.length > 0 ? (
        <div className="status-section mb-4">
          <h5 className="status-header">
            Status:
            <Tag bordered={false} color="green">
              {dispatchRecords[0]?.dispatch_records?.some(
                (record) => record.awaiting_pre_arrival === false
              )
                ? "Pre Arrival Awaiting"
                : dispatchRecords[0]?.status}
            </Tag>
          </h5>
        </div>
      ) : (
        ""
      )}
      {dispatchRecords?.length > 0 && (
        <>
          <h5 className="mt-3 mb-3 text-gray mx-2">Uploaded Documents</h5>
          <div
            style={{
              maxHeight: "400px",
              overflowY: "auto",
              border: "1px solid #ddd",
            }}
          >
            <table className="table table-bordered table-hover table-striped">
              <thead className="thead-dark">
                <tr>
                  <th className="text-center">Quantity</th>
                  {/* <th className='text-center'>Remarks</th> */}
                  <th className="text-center">Uploaded Documents</th>
                  <th className="text-center">Upload More Documents</th>
                  <th className="text-center">Delivery Status </th>
                  <th className="text-center">Pre-Arrival Status </th>
                </tr>
              </thead>
              <tbody>
                {dispatchRecords?.map((procurement) =>
                  procurement.dispatch_records.map((dispatchRecord) => {
                    const uploadedPatterns = dispatchRecord.documents.map(
                      (doc) => doc.pattern
                    );
                    const remainingDocuments = allDocumentTypes.filter(
                      (docType) => !uploadedPatterns.includes(docType)
                    );
                    const payloadId = dispatchRecord.id;
                    const transformedArray = remainingDocuments.map((item) =>
                      item.toLowerCase().replace(/\s+/g, "_")
                    );
                    return (
                      <tr key={dispatchRecord.id}>
                        <td className="align-middle text-center">
                          {dispatchRecord.quantity} {FullList.unit_of_measure}
                        </td>
                        <td>
                          <table className="table table-sm table-borderless">
                            <tbody>
                              {dispatchRecord.documents.map((document) => (
                                <tr key={document.id}>
                                  <td className="text-center mt-1">
                                    <a
                                      href={document.file}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="text-decoration-none text-center"
                                    >
                                      {/* <i className="fas fa-file-pdf mr-2 mx-2"></i> */}
                                      {document.pattern.replaceAll("_", " ")}
                                    </a>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </td>
                        <td>
                          {transformedArray?.map((docType) => (
                            <div className="mt-2 text-center" key={docType}>
                              <label className="font-weight-bold">
                                {docType.replaceAll("_", " ")}
                              </label>
                              {docType === "mandi_document" ? (
                                <>
                                  <input
                                    type="file"
                                    accept=".pdf"
                                    multiple
                                    onChange={(e) =>
                                      handleFileChange(e, docType)
                                    }
                                    className="form-control-file my-2"
                                  />
                                </>
                              ) : (
                                <input
                                  type="file"
                                  accept=".pdf"
                                  onChange={(e) => handleFileChange(e, docType)}
                                  className="form-control-file my-2"
                                />
                              )}
                            </div>
                          ))}
                          {transformedArray?.length > 0 && (
                            <div className="text-center">
                              <button
                                onClick={() => handleUploadClick(payloadId)}
                                className="btn btn-primary btn-sm mt-2 text-center"
                              >
                                Upload
                              </button>
                            </div>
                          )}
                        </td>
                        <td className="align-middle text-center">
                          {dispatchRecord.is_delivered
                            ? "Delivered"
                            : "Not Delivered"}
                        </td>
                        <td>
                          {!dispatchRecord?.awaiting_pre_arrival ? (
                            <form
                              onSubmit={(e) => handlePreArrival(e, payloadId)}
                            >
                              <Grid item xs={12} sm={12} md={12}>
                                <div
                                  className="text-primary text-underline"
                                  style={{ fontSize: "14px" }}
                                >
                                  Vehicle Number
                                </div>
                                <input
                                  type="text"
                                  name="vehicle_number"
                                  onChange={(e) =>
                                    setVehicle({
                                      ...Vehicle,
                                      [e.target.name]: e.target.value,
                                    })
                                  }
                                  required
                                  style={{
                                    fontSize: "15px",
                                    padding: "8px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    width: "100%",
                                    marginTop: "8px",
                                  }}
                                />
                              </Grid>

                              <Grid item xs={12} sm={12} md={12}>
                                <div
                                  className="text-primary text-underline mt-2"
                                  style={{ fontSize: "14px" }}
                                >
                                  Vehicle Type
                                </div>
                                <input
                                  type="text"
                                  name="vehicle_type"
                                  onChange={(e) =>
                                    setVehicle({
                                      ...Vehicle,
                                      [e.target.name]: e.target.value,
                                    })
                                  }
                                  required
                                  style={{
                                    fontSize: "15px",
                                    padding: "8px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    width: "100%",
                                    marginTop: "8px",
                                  }}
                                />
                              </Grid>
                              <div className="text-center">
                                <button
                                  type="submit"
                                  className="btn btn-primary btn-sm mt-2 text-center"
                                >
                                  Upload
                                </button>
                              </div>
                            </form>
                          ) : (
                            <div className="text-center align-middle">
                              Completed
                            </div>
                          )}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};
